import {login, logout, getInfo} from '@/api/login'
import {getToken, setToken, setCustomToken,removeToken} from '@/utils/auth'

const user = {
  state: {
    token: getToken(),
    name: '',
    avatar: '',
    roles: []
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    }
  },

  actions: {
    // 登录
    Login({commit}, userInfo) {
      const username = userInfo.username.trim()
      return new Promise((resolve, reject) => {
        login(username, userInfo.password).then(response => {
          const data = response.data
          const tokenStr = data.tokenValue
          setToken(tokenStr)
          setCustomToken("adminNum", data.id)
          setCustomToken("adminPhone", data.phone)
          setCustomToken("username", username)
          setCustomToken("appid", data.appid)
          setCustomToken("shopId", data.shopId)
          if (data.printerSn != null && data.printerSn !== ''){
            setCustomToken("printerSn", data.printerSn)
          }
          commit('SET_TOKEN', tokenStr)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetInfo({commit, state}) {
      return new Promise((resolve, reject) => {
        getInfo().then(response => {
          const data = response.data
          if (data.menuList && data.menuList.length > 0) { // 验证返回的roles是否是一个非空数组
            commit('SET_ROLES', data.menuList)
          } else {
            reject('getInfo: roles must be a non-null array !')
          }
          commit('SET_NAME', data.admin.username)
          commit('SET_AVATAR', data.admin.photo)
          setCustomToken("permissionList", data.permissionList);
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    LogOut({commit, state}) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          removeToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut({commit}) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js